import { postItem, putItem } from "../../../api/api-methods";

export const generalRepoMixin = {
  data() {
    return {
      errors: [],
      showAlert: false,
      alertType: 'success',
      alertText: 'Registro exitoso',
      alertColor: null,
    }
  },

  methods: {
    async postAddress(addresObj) {
      try {
        const responseData = await postItem('/app-personas/direccion', addresObj)
        // console.log('Respuesta direccion: ', responseData);
        if (responseData.e) {
          this.errors.push('No se pudo crear la dirección: ' + responseData.e.join(','))
          return responseData
        }
        addresObj.id = responseData.id
      } catch (error) {
        this.errors.push('Error al intentar crear direccion')
        console.error('Error al intentar crear direccion.', error);
      }
    },
    async updateAddress(addresObj, idAddress) {
      try {
        const responseData = await putItem(`/app-personas/direccion/${idAddress}`, addresObj)
        // console.log('Respuesta actualizar direccion: ', responseData);
        if (responseData.e) {
          this.errors.push('No se pudo actualizar la dirección: ' + responseData.e.join(','))
        }
      } catch (error) {
        this.errors.push('Error al intentar actualizar direccion')
        console.error('Error al intentar actualizar direccion.', error);
      }
    },
    async postPersonalInfo(personalInfoObj) {
      try {
        const responseData = await postItem('/app-personas/datos-personales', personalInfoObj)
        // console.log('Respuesta datos personales: ', responseData);
        if (responseData.e) {
          this.errors.push('No se pudieron crear los datos personales: ' + responseData.e.join(','))
          return
        }
        personalInfoObj.id = responseData.id
      } catch (error) {
        this.errors.push('Error al intentar crear datos personales')
        console.error('Error al intentar crear datos personales.', error);
      }
    },
    async updatePersonalInfo(personalInfoObj, personalInfoId) {
      try {
        const responseData = await putItem(`/app-personas/datos-personales/${personalInfoId}`, personalInfoObj)
        // console.log('Respuesta actualizar datos personales: ', responseData);
        if (responseData.d) {
          this.errors.push('No se pudieron actualizar los datos personales: ' + responseData.e.join(','))
        }
      } catch (error) {
        this.errors.push('Error al intentar actualizar datos personales')
        console.error('Error al intentar actualizar personales.', error);
      }
    },
    async postTaxInfo(taxInfoObj) {
      try {
        const responseData = await postItem('/app-personas/datos-fiscales', taxInfoObj)
        // console.log('Respuesta datos fiscales: ', responseData);
        if (responseData.e) {
          this.errors.push('No se pudieron crear los datos fiscales: ' + responseData.e.join(','))
          return
        }
        taxInfoObj.id = responseData.id
      } catch (error) {
        this.errors.push('Error al intentar crear datos fiscales')
        console.error('Error al intentar crear datos fiscales.', error);
      }
    },
    async updateTaxInfo(taxInfoObj, taxInfoId) {
      try {
        const responseData = await putItem(`/app-personas/datos-fiscales/${taxInfoId}`, taxInfoObj)
        // console.log('Respuesta actualizar datos fiscales: ', responseData);
        if (responseData.e) {
          this.errors.push('No se pudieron crear los datos fiscales: ' + responseData.e.join(','))
        }
      } catch (error) {
        this.errors.push('Error al intentar actualizar datos fiscales')
        console.error('Error al intentar actualizar datos fiscales.', error);
      }
    },
    async postUser(userObj) {
      try {
        const responseData = await postItem('/app-land/crear-usuario', userObj)
        // console.log('Respuesta usuario: ', responseData);
        if (responseData.e) {
          this.errors.push('No se pudo crear el usuario: ' + responseData.e.join(','))
          return
        }
        userObj.id = responseData.id_objeto
      } catch (error) {
        this.errors.push('Error al intentar crear usuario')
        console.error('Error al intentar crear usuario.', error);
      }
    },
  }
}